import {
	useQuery,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { QuizType } from "$/modules/appwrite/types/collections";
import { certificateTemplatesQueryOptions } from "$/modules/exam/lib/queries";
import { CertificateTemplateEditor } from "$/modules/exam/ui/certificate-template-editor";
import { projectQueryOptions } from "$/modules/projects/lib/queries";
import { Card, CardContent } from "$/modules/shared/ui/card";
import { ConstructionHeader } from "$/modules/shared/ui/construction-header";

export const Route = createFileRoute(
	"/$locale/$userId/projects/$projectId/certificates/",
)({
	component: CertificateEditorPage,
	loader: async ({ params, context: { queryClient } }) => {
		await queryClient.ensureQueryData({
			...projectQueryOptions(params.userId, params.projectId),
			revalidateIfStale: true,
		});
	},
});

function CertificateEditorPage() {
	const t = useTranslations("exam");
	const { userId, projectId } = Route.useParams();
	const { data: project } = useSuspenseQuery(
		projectQueryOptions(userId, projectId),
	);
	const queryClient = useQueryClient();
	const templateOptions = certificateTemplatesQueryOptions(userId);
	const { data: templates } = useQuery({
		...templateOptions,
		enabled: project.quizType === QuizType.Exam,
	});

	return (
		<>
			<ConstructionHeader
				titleKey="project.sidebar.certificates"
				description={project.name}
			/>
			{project.quizType !== QuizType.Exam ? (
				<Card className="mt-6 border border-warning-200">
					<CardContent className="p-6 text-sm text-foreground-600">
						{t("certificateEditorExamOnly")}
					</CardContent>
				</Card>
			) : (
				<CertificateTemplateEditor
					templates={templates?.rows ?? []}
					onSaved={() =>
						void queryClient.invalidateQueries({
							queryKey: templateOptions.queryKey,
						})
					}
				/>
			)}
		</>
	);
}
